import { memo } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}

const Button = ({
    children,
    className,
    color = "primary",
    disabled = false,
    fullWidth = false,
    loading = false,
    size = "lg",
    variant = "contained",
    shadow = false,
    icon = false,
    height = "md",
    ...props
}) => {
    const baseClasses = "flex items-center justify-center shrink-0 whitespace-nowrap rounded-lg hover:opacity-80 hover:border-transparent transition-all group";

    // Size classes
    const sizeClasses = {
        lg: "px-2 h-10 text-sm font-medium",
        xl: "px-2 h-10 text-sm font-medium"
    };

    // Height classes
    const heightClasses = {
        sm: "h-8",
        md: "h-10",
        lg: "h-11"
    };

    // Variant and color combinations
    const variantColorClasses = {
        contained: {
            primary: "text-white bg-[#115B9D]",
            secondary: "text-[#115B9D] bg-btn"
        },
        dim: {
            primary: "bg-white-2 text-black-2"
        }
    };

    // Build the class string manually
    let buttonClasses = `${baseClasses} ${sizeClasses[size] || sizeClasses.lg} ${heightClasses[height] || heightClasses.md}`;

    // Add variant and color classes
    if (variantColorClasses[variant]?.[color]) {
        buttonClasses += ` ${variantColorClasses[variant][color]}`;
    }

    // Add conditional classes
    if (fullWidth) buttonClasses += " w-full";
    if (disabled) buttonClasses += " cursor-not-allowed shadow-none";
    if (shadow) buttonClasses += " shadow-box";
    if (icon) buttonClasses += " xl:w-5 sm:h-5";
    if (className) buttonClasses += ` ${className}`;
    if (disabled || loading) buttonClasses += " !bg-gray-4 cursor-not-allowed";

    return (
        <button
            className={buttonClasses}
            {...props}
            disabled={disabled || loading}
        >
            <span className={cn("flex items-center", loading && "hidden")}>
                {children}
            </span>
            {loading && (
                <AiOutlineLoading3Quarters className="animate-spin text-[#115B9D] size-5" />
            )}
        </button>
    );
};

export default memo(Button);